<div class="blog-search">
  <app-icon [icon]="searchIcon" [size]="18" class="blog-search__icon" />
  <input
    type="search"
    class="blog-search__input"
    [placeholder]="copy.searchPlaceholder"
    [value]="value()"
    (input)="onInput($event)"
  />
</div>
